<template>
  <b-alert
  v-if="alertCountDown > 0"
    id="idAlert"
    :style="'height: 6rem; z-index:' + zIndex + '; width: 40%; position:fixed; top: 7rem; left: 30%; text-align: left'"
    :variant="variant"
    fade
    dismissible
    :show="alertCountDown"
    @dismiss-count-down="countDownChanged"
  >
  <b-row align-v="center" style="font-size: large;">
  <div id="idAlertIcon">
    <font-awesome-icon :icon="this.icon" size="lg" :style="{color: this.iconColor}" />
  </div>
  <strong>{{ this.headline }}</strong>
  </b-row>
  <b-row>
     <div id="idAlertMsg">
    {{ this.msg }}
     </div>
    </b-row>
  </b-alert>
</template>

<script>
export default {
  data() {
    return {
      icon: null,
      iconColor: null,
      variant: null,
      headline: "",
      msg: "",
      zIndex: 20,
      alertCountDown: 0
    };
  },
  created() {
  },
  mounted() {
    this.$root.$on('showAlert', (props) => {
      switch (props.type) {
      case "info":
        this.icon = "check-circle";
        this.headline = "Success!"
        this.variant = "success";
        this.iconColor = "#1E4B21"
        break;
      case "error":
        this.icon = "ban";
        this.headline = "Error!"
        this.variant = "danger";
        this.iconColor = "#601F14"
        break;
      case "warning":
        this.icon = "exclamation-triangle"
        this.headline = "Warning!"
        this.variant = "warning"
        this.iconColor = "#f5ca20"
    }
    this.msg = props.msg
    if(props.force) this.zIndex = 1100
    else this.zIndex = 20
    this.alertCountDown = 10
    })
  },
  methods: {
    countDownChanged(alertCountDown) {
      this.alertCountDown = alertCountDown;
    }
  }
};
</script>

<style scoped>
#idAlertIcon {
  margin-right: 1rem;
  margin-left: .5rem;
}
#idAlertMsg {
  margin-left: 3rem;
}
</style>